
















import { Component, Prop, Vue } from 'vue-property-decorator';

type Data = {
  title: string;
  list: Array<{
    label: string;
    value: string | number;
    highlighted?: boolean;
  }>;
};

@Component({
  components: {}
})
export default class ResumeCard extends Vue {
  @Prop({
    default: () => ({
      title: '',
      list: []
    })
  })
  data!: Data;
}
